"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _helpers = require("react-platform-components/dist/helpers");
var _AddressInfo = require("./AddressInfo");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SecondaryInfo = function SecondaryInfo(props) {
  var product = props.product;
  var AddressInfo = props.addressInfoComponent || _AddressInfo.AddressInfo;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, product.created_at && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, (0, _helpers.formatDate)(product.created_at)), /*#__PURE__*/_react.default.createElement(AddressInfo, {
    product: product
  })), props.renderExtraInfo && props.renderExtraInfo(product));
};
exports.SecondaryInfo = SecondaryInfo;